export default {
  evaluateList: '/admin/evaluation/list', // 评价列表
  evaluateStat: '/admin/evaluation/statistics', // 评价统计
  evaluateExport: '​/admin/evaluation/export', // 评价导出
  evaluateDetail: '/admin/evaluation/{id}', // 评论详情
};
